function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.7,0c2.4-0.2,4.9,0.7,5,3s-4.2,7.3-4.9,8c-0.7,0.7-3.7,4-3.7,4s5.7,0.3,6.9,4c1.1,3.7-2.1,8.2-3.7,9.5 c-1.6,1.3-3.6,2.4-4,2.7s0.5,0.7,0,0.7c-0.3,0-1-0.6-0.6-1.1c0.4-0.6,5.9-2.4,7.2-8.3c1.3-5.9-4.6-5.9-6-6s-2.2-0.7-1.4-1.7 c0.7-1,9.3-10.2,8.5-12c-0.9-1.9-4.3-0.4-5.4,0.1c-1.1,0.6-3.4,2-3.7,2.2s-1.1,0.3-0.6-0.6C15.7,3.6,18.8,0.3,21.7,0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8,9.6c-1.3,0.1-4,1-5.9,7.2S6.4,27.7,9.7,27s6.9-5.7,7-5.9s0-0.9-0.7-0.1s-5,5.6-7.6,4.4 c-2.6-1.1-1.1-11.5,3.3-13.8c0,0,1.4-0.9,2.7,1.7S15.8,9.4,11.8,9.6z"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e4cb65b3.svg";
export { ForwardRef as ReactComponent };